'use client';

import { c as _c } from "react/compiler-runtime";
import type { MarketId } from '@morpho-org/blue-sdk';
import { type AvatarSize, DynamicAvatarsStack, type DynamicAvatarsStackAlign } from '@morpho-org/ui-v6/client';
import { formatters } from '@morpho-org/ui-v6/utils';
import { MarketCuratorHoverCard } from '@/components/MarketPage/components/MarketCuratorHoverCard';
import type { MarketCurator } from '../config/TableMarket.types';
export interface MarketTrustedByCuratorStackProps {
  curators: MarketCurator[];
  marketId: MarketId;
  className?: string;
  avatarSize?: AvatarSize;
  maxTokensCount?: number;
  align?: DynamicAvatarsStackAlign;
}
const MarketTrustedByCuratorStack = t0 => {
  const $ = _c(8);
  const {
    className,
    curators,
    avatarSize: t1,
    maxTokensCount: t2,
    align: t3
  } = t0;
  const avatarSize = t1 === undefined ? "regular" : t1;
  const maxTokensCount = t2 === undefined ? 5 : t2;
  const align = t3 === undefined ? "left" : t3;
  let t4;
  if ($[0] !== curators) {
    t4 = curators.map(_temp2);
    $[0] = curators;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const dynamicAvatarStackItems = t4;
  let t5;
  if ($[2] !== align || $[3] !== avatarSize || $[4] !== className || $[5] !== dynamicAvatarStackItems || $[6] !== maxTokensCount) {
    t5 = <DynamicAvatarsStack className={className} items={dynamicAvatarStackItems} maxTokensCount={maxTokensCount} avatarSize={avatarSize} isMobileSupportEnabled={true} align={align} />;
    $[2] = align;
    $[3] = avatarSize;
    $[4] = className;
    $[5] = dynamicAvatarStackItems;
    $[6] = maxTokensCount;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default MarketTrustedByCuratorStack;
function _temp(vault) {
  const formattedTotalAssets = formatters.short.digits(2).trailingZero(false).unit("$").default("-").of(vault.totalAssetsUsd);
  return {
    id: `${vault.chainId}:${vault.address}`,
    address: vault.address,
    vaultName: vault.name,
    imageURI: vault.imageUri,
    chainId: vault.chainId,
    vaultDeposit: formattedTotalAssets,
    isVaultV2: vault.isVaultV2
  };
}
function _temp2(curator) {
  const vaults = curator.vaults.map(_temp);
  return {
    hoverCardContent: <MarketCuratorHoverCard curatorName={curator.name} curatorLogoURI={curator.image} vaults={vaults} />,
    logoUrl: curator.image
  };
}